/*
 * @Author: dengyongliang
 * @Date: 2021-05-24 11:10:06
 * @LastEditTime: 2021-07-01 09:19:34
 * @LastEditors: dengyongliang
 * @Description: NULL
 */
'use strict'
import axios from '@/global/axios.js'
import * as action from '@/actions/domainSafe'

// 域名安全服务列表
export const DOMAIN_SAFE_LIST = (pageNum, pageSize, domainName, domainSuffixs, otherSuffix, allSuffix, groupIds, importantFlag, renewFlag, updateFlag, backendLockFlag, transferLockFlag, deleteLockFlag, whoisPrivacyFlag) => {
  return axios({
    url: action.DOMAIN_SAFE_LIST,
    method: 'POST',
    data: { pageNum, pageSize, domainName, domainSuffixs, otherSuffix, allSuffix, groupIds, importantFlag, renewFlag, updateFlag, backendLockFlag, transferLockFlag, deleteLockFlag, whoisPrivacyFlag }
  })
}
// 设置域名保护级别
export const SET_PROTECT_LEVEL = (protectLevel, domainIds) => {
  return axios({
    url: action.SET_PROTECT_LEVEL,
    method: 'POST',
    data: { protectLevel, domainIds }
  })
}
// 设置域名自动续费
export const SET_AUTO_RENEW = (autoRenewFlag, domainId) => {
  return axios({
    url: action.SET_AUTO_RENEW,
    method: 'POST',
    data: { autoRenewFlag, domainId }
  })
}
export const BATCH_SET_AUTO_RENEW = (autoRenewFlag, domainIds) => {
  return axios({
    url: action.BATCH_SET_AUTO_RENEW,
    method: 'POST',
    data: { autoRenewFlag, domainIds }
  })
}
// 设置域名禁止更新
export const SET_PROHIBIT_UPDATE = (prohibitUpdate, domainId) => {
  return axios({
    url: action.SET_PROHIBIT_UPDATE,
    method: 'POST',
    data: { prohibitUpdate, domainId }
  })
}
export const BATCH_SET_PROHIBIT_UPDATE = (prohibitUpdate, domainIds) => {
  return axios({
    url: action.BATCH_SET_PROHIBIT_UPDATE,
    method: 'POST',
    data: { prohibitUpdate, domainIds }
  })
}
export const SET_PROHIBIT_TRANSFER = (prohibitTransfer, domainId) => {
  return axios({
    url: action.SET_PROHIBIT_TRANSFER,
    method: 'POST',
    data: { prohibitTransfer, domainId }
  })
}
export const BATCH_SET_PROHIBIT_TRANSFER = (prohibitTransfer, domainIds) => {
  return axios({
    url: action.BATCH_SET_PROHIBIT_TRANSFER,
    method: 'POST',
    data: { prohibitTransfer, domainIds }
  })
}
export const SET_PROHIBIT_DELETE = (prohibitDelete, domainId) => {
  return axios({
    url: action.SET_PROHIBIT_DELETE,
    method: 'POST',
    data: { prohibitDelete, domainId }
  })
}
export const BATCH_SET_PROHIBIT_DELETE = (prohibitDelete, domainIds) => {
  return axios({
    url: action.BATCH_SET_PROHIBIT_DELETE,
    method: 'POST',
    data: { prohibitDelete, domainIds }
  })
}
export const OPEN_WHOIS_PRIVACY = (domainId) => {
  return axios({
    url: action.OPEN_WHOIS_PRIVACY,
    method: 'POST',
    data: { domainId }
  })
}
// 购买域名注册局锁定
export const BUY_BACKEND_LOCK = () => {
  return axios({
    url: action.BUY_BACKEND_LOCK,
    method: 'POST',
    data: {}
  })
}
// 续费域名注册局锁定
export const RENEW_BACKEND_LOCK = () => {
  return axios({
    url: action.RENEW_BACKEND_LOCK,
    method: 'POST',
    data: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/domainSafe.js